import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  paperHeaderTypography: {
    fontWeight: 500,
  },
}))

export default styles
